const fonts = {
  tinyrem: 1,
  smallrem: 0.76,
  tiny: 12,
  xtiny:13,
  small: 15,
  medium: 16,
  large: 18,
  xLarge: 22, 
}

export const weight = {
  normal: 400,
  medium:500,
  bold: 600,
  xBold: 700,
  xxBold: 800
}

export default fonts
